import { Component, EventEmitter, Output } from "@angular/core";

@Component({
  selector: "app-attachment",
  templateUrl: "./attachment.component.html",
  styleUrls: ["./attachment.component.scss"],
})
export class AttachmentComponent {
  @Output() submit = new EventEmitter<File[]>();
  @Output() navigateBack = new EventEmitter();

  acceptedFileFormats = ".tiff, .gif, .png, .jpg, .jpeg, .pdf, .doc, .docx, .xls, .ppt, .eps, .txt, .rtf, .html";
  fileSizeLimit = 500000000; // 5*10^8 bytes - 500 MB

  selectedFiles: File[] = [];

  onUserSelectedFile(event: any): void {
    let files: FileList = event.target.files as FileList;
    let filesSize = 0;

    for (const file of Array.from(files)) {
      filesSize += file.size;
      if (this.selectedFiles.length < 10 && filesSize <= this.fileSizeLimit) {
        this.selectedFiles.push(file);
      }
    }
  }

  deleteFile(file: File) {
    this.selectedFiles.splice(this.selectedFiles.indexOf(file), 1);
  }

  async submitAttachments() {
    this.submit.emit(this.selectedFiles);
  }

  getFilesNumberText() {
    let text = "No file chosen";

    if (this.selectedFiles.length > 1) {
      text = this.selectedFiles.length + " files";
    } else if (this.selectedFiles.length === 1) {
      text = "1 file";
    }

    return text;
  }

  isLimitReached() {
    return this.selectedFiles.length >= 10;
  }

  navigateToPreviousPage() {
    this.navigateBack.emit();
  }
}
